import React, { useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  templateGetParticularActions,
  templateCountAdd,
} from "../../Store/Actions/TemplateActions";
import {
  resumeEditActions,
  sampleResumeById,
} from "../../Store/Actions/ResumeActions";
import { useHistory, useParams } from "react-router";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import "./SideTemplate.scss";
import { changeLayout } from "../../Store/Actions/LayoutActions";
import { EDITOR_DATA_ADD } from "../../Store/Constants/EditorConstants";
import { TemplateContext } from "../../Context/templateContext";

function SideTemplate(props) {
  const path = window.location.pathname;
  const { id } = useParams();

  const history = useHistory();
  const dispatch = useDispatch();

  const [tempData, setTempData] = useState("");

  const templateList = useSelector((state) => state.templateList.list);
  const editorData = useSelector((state) => state.editorData);
  const resume = useSelector((state) => state.resumeGetById);
  const templateData = useSelector((state) => state.TemplateParticular.data);
  // const { canCalculate, setCanCalculate } = useContext(TemplateContext);

  useEffect(() => {
    setTempData(templateList);
  }, [templateList]);

  const changeTemplate = (res) => {
    if (path && path.includes("create")) {
      dispatch(templateGetParticularActions(res.template_code));

      let cont = res;
      let data = { ...props.resumeFields };
      {
        Object.keys(data && data.sectionPosition).map((keyName, i) => {
          if (keyName == "lsbar" || keyName == "rsbar") {
            data &&
              data.sectionPosition &&
              data.sectionPosition[keyName] &&
              data.sectionPosition[keyName].map((data, index) => {
                let isPresentLeft =
                  cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition.lsbar.findIndex(
                    (x) => x == data
                  );
                let isPresentRight =
                  cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition.rsbar.findIndex(
                    (x) => x == data
                  );

                if (isPresentLeft == -1 && isPresentRight == -1) {
                  if (data == "profile") {
                  } else if (data == "summary") {
                  } else {
                    if (cont.settings.customization.resumeLayout == "double") {
                      cont &&
                        cont.settings &&
                        cont.settings.sectionPosition &&
                        cont.settings.sectionPosition.rsbar.push(data);
                    } else {
                      cont &&
                        cont.settings &&
                        cont.settings.sectionPosition &&
                        cont.settings.sectionPosition.lsbar.push(data);
                    }
                  }
                } else {
                }
              });
          }
        });
      }

      ["lsbar", "rsbar"].map((position, index) => {
        cont &&
          cont.settings &&
          cont.settings.sectionPosition[position].map((sect, index) => {
            let isPresentLeft =
              data &&
              data.sectionPosition &&
              data.sectionPosition.lsbar.findIndex((x) => x == sect);
            let isPresentRight =
              data &&
              data.sectionPosition &&
              data.sectionPosition.rsbar.findIndex((x) => x == sect);

            if (isPresentLeft == -1 && isPresentRight == -1) {
              if (sect == "profile") {
              } else if (sect == "summary") {
              } else {
                cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition[position].splice(index, 1);
              }
            } else {
            }
          });
      });

      data["sectionPosition"] =
        cont && cont.settings && cont.settings.sectionPosition;
      data["editorSettings"] =
        cont && cont.settings && cont.settings.editorSettings;
      data["layout"] = cont && cont.settings && cont.settings.layout;
      dispatch(changeLayout(cont && cont.settings && cont.settings.layout));

      // For Premium Handle

      const checkLockedFeature =
        data["lockedFeatures"] === undefined ? false : true;
      if (!checkLockedFeature) {
        data["lockedFeatures"] = [];
      }
      const objWithIdIndex =
        data &&
        data["lockedFeatures"] &&
        data["lockedFeatures"].findIndex((obj) => obj === "template");
      // let res = { ...editorData }
      if (res && res.usage == "2") {
        if (objWithIdIndex === -1) {
          data["lockedFeatures"].push("template");
        }
      } else {
        if (
          data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].length > 0
        ) {
          if (objWithIdIndex > -1) {
            data &&
              data["lockedFeatures"] &&
              data["lockedFeatures"].splice(objWithIdIndex, 1);
          }
        }
      }

      data.customization = res.settings.customization;
      data.template_id = res.template_code;
      props.setResumeFields(data);
      dispatch({
        type: EDITOR_DATA_ADD,
        payload: data,
      });
      dispatch(sampleResumeById(id, data, "isAuth"));
    } else {
      dispatch(templateGetParticularActions(res.template_code));
      dispatch(templateCountAdd(res.template_code));

      let cont = res;
      let data = { ...props.resumeFields };
      // For pushing newly added section into template section

      {
        Object.keys(data && data.sectionPosition).map((keyName, i) => {
          if (keyName == "lsbar" || keyName == "rsbar") {
            data &&
              data.sectionPosition &&
              data.sectionPosition[keyName] &&
              data.sectionPosition[keyName].map((data, index) => {
                let isPresentLeft =
                  cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition.lsbar.findIndex(
                    (x) => x == data
                  );
                let isPresentRight =
                  cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition.rsbar.findIndex(
                    (x) => x == data
                  );

                if (isPresentLeft == -1 && isPresentRight == -1) {
                  if (data == "profile") {
                  } else if (data == "summary") {
                  } else {
                    if (cont.settings.customization.resumeLayout == "double") {
                      cont &&
                        cont.settings &&
                        cont.settings.sectionPosition &&
                        cont.settings.sectionPosition.rsbar.push(data);
                    } else {
                      cont &&
                        cont.settings &&
                        cont.settings.sectionPosition &&
                        cont.settings.sectionPosition.lsbar.push(data);
                    }
                  }
                } else {
                }
              });
          }
        });
      }

      ["lsbar", "rsbar"].map((position, index) => {
        cont &&
          cont.settings &&
          cont.settings.sectionPosition[position].map((sect, index) => {
            let isPresentLeft =
              data &&
              data.sectionPosition &&
              data.sectionPosition.lsbar.findIndex((x) => x == sect);
            let isPresentRight =
              data &&
              data.sectionPosition &&
              data.sectionPosition.rsbar.findIndex((x) => x == sect);

            if (isPresentLeft == -1 && isPresentRight == -1) {
              if (sect == "profile") {
              } else if (sect == "summary") {
              } else {
                cont &&
                  cont.settings &&
                  cont.settings.sectionPosition &&
                  cont.settings.sectionPosition[position].splice(index, 1);
              }
            } else {
            }
          });
      });

      data["sectionPosition"] =
        cont && cont.settings && cont.settings.sectionPosition;
      data["editorSettings"] =
        cont && cont.settings && cont.settings.editorSettings;

      //update Layout
      let layoutArray = data["layout"];
      let movedArray = cont && cont.settings && cont.settings.layout;

      ["lsbar", "rsbar"].map((position, index) => {
        layoutArray[index].map((data) => {
          let tempData = data;
          let indexNumLeft = movedArray[0].findIndex(
            (x) => x.section == data.section
          );
          let indexNumRight = movedArray[1].findIndex(
            (x) => x.section == data.section
          );

          if (indexNumLeft == -1 && indexNumRight == -1) {
            if (cont.settings.customization.resumeLayout == "single") {
              movedArray[0].push(tempData);
            } else {
              movedArray[1].push(tempData);
            }
          } else {
            let itemIndex = data.itemIndexes;
            if (indexNumLeft != -1) {
              let tempObj = movedArray[0][indexNumLeft];
              let arr = tempObj.itemIndexes;
              itemIndex &&
                itemIndex.map((data) => {
                  const index = tempObj.itemIndexes.findIndex((e) => e == data);
                  if (index === -1) {
                    arr.push(data);
                  } else {
                    arr[index] = data;
                  }
                });

              tempObj.itemIndexes = arr;
              movedArray[0].splice(indexNumLeft, 1, tempObj);
            } else {
              let tempObj = movedArray[1][indexNumRight];
              let arr = tempObj.itemIndexes;
              itemIndex &&
                itemIndex.map((data) => {
                  const index = tempObj.itemIndexes.findIndex((e) => e == data);
                  if (index === -1) {
                    arr.push(data);
                  } else {
                    arr[index] = data;
                  }
                });

              tempObj.itemIndexes = arr;
              movedArray[1].splice(indexNumRight, 1, tempObj);
            }
          }
        });
      });

      data["layout"] = movedArray;
      dispatch(changeLayout(movedArray));

      const checkLockedFeature =
        data["lockedFeatures"] === undefined ? false : true;
      if (!checkLockedFeature) {
        data["lockedFeatures"] = [];
      }
      const objWithIdIndex =
        data &&
        data["lockedFeatures"] &&
        data["lockedFeatures"].findIndex((obj) => obj === "template");
      // let res = { ...editorData }
      if (res && res.usage == "2") {
        if (objWithIdIndex === -1) {
          data["lockedFeatures"].push("template");
        }
      } else {
        if (
          data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].length > 0
        ) {
          if (objWithIdIndex > -1) {
            data &&
              data["lockedFeatures"] &&
              data["lockedFeatures"].splice(objWithIdIndex, 1);
          }
        }
      }
      data.customization = res.settings.customization;
      props.setResumeFields(data);
      dispatch({
        type: EDITOR_DATA_ADD,
        payload: data,
      });
      const body = {
        title:
          resume && resume.resume && resume.resume.title
            ? resume.resume.title
            : "",
        body: "Body123",
        content: JSON.stringify(data),
        completed: false,
        isLetter:
          resume && resume.resume && resume.resume.isLetter
            ? resume.resume.isLetter
            : 0,
        type: "resume",
        template_id: res.template_code,
      };

      dispatch(
        resumeEditActions(
          id,
          body
          //   res.settings.customization,
          //   cont && cont.settings && cont.settings.sectionPosition,
          //   data["editorSettings"]
        )
      );
      //   setCanCalculate(true);
    }
  };

  const handleChange = (checked) => {
    let data = { ...props.resumeFields };

    const body = {
      title:
        resume && resume.resume && resume.resume.title
          ? resume.resume.title
          : "",
      body: "Body",
      content: JSON.stringify(data),
      completed: false,
      isLetter: checked == "letter" ? 1 : 0,
      type: "resume",
      template_id: resume && resume.resume && resume.resume.template_id,
    };
    dispatch(resumeEditActions(id, body, "sizeHandle"));
  };
  return (
    <div
      id="sidebarTemplate"
      className="sidebarTemplate"
      style={{ width: props && props.isSideBar ? "392px" : "0" }}
    >
      <div>
        <p className="text-center">Select a template</p>
        <span className="tempclosebtn" onClick={props.hideTemplate}>
          ×
        </span>
        <div className="row m-0 template_list_items">
          {tempData &&
            tempData.data &&
            tempData.data
              .filter((data) => data.status == "1")
              .map((res, index) => {
                let image = JSON.parse(res.image, true);
                return (
                  <div
                    style={{ position: "relative" }}
                    key={index}
                    className=" col-md-6 mb-2 template_item"
                    onClick={() => changeTemplate(res)}
                  >
                    <div
                      className={`template-image ${
                        templateData &&
                        templateData.template_code == res.template_code
                          ? "active_template"
                          : ""
                      }`}
                    >
                      <img
                        className="w-100 h-100"
                        variant="top"
                        src={image.key}
                      />
                      <button className="btn probtn side-template-pro">
                        <img
                          src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/zap.svg`}
                          alt="zap"
                          className="mr-1"
                        />
                        {res && res.usage == "2" ? "Pro" : "Free"}
                      </button>
                    </div>
                    <p
                      className={`m-0 p-2 ${
                        templateData &&
                        templateData.template_code == res.template_code
                          ? "active_template_text"
                          : ""
                      }`}
                      style={{ textAlign: "center", fontSize: "13px" }}
                    >
                      {res.name}
                    </p>
                  </div>
                );
              })}
          <div className="footer-fixed-component p-3">
            <div>
              <button
                className="btn upgradebtn w-100"
                style={{ maxWidth: "inherit" }}
                onClick={props.hideTemplate}
              >
                Continue Editing
              </button>
            </div>
            <div className="row mt-2 justify-content-between ">
              <p className="pt-2 col-md-6">Document size:</p>
              <div className="col-md-6">
                <div className="row type-switch-div justify-content-between">
                  <div
                    className={
                      resume && resume.resume && resume.resume.isLetter
                        ? ` type-switch-selected col-md-6 type-switch`
                        : "col-md-6 type-switch"
                    }
                    onClick={() => handleChange("letter", "document_size")}
                  >
                    Letter
                  </div>
                  <div
                    className={
                      resume && resume.resume && resume.resume.isLetter
                        ? ` col-md-6 type-switch`
                        : " type-switch-selected col-md-6 type-switch"
                    }
                    onClick={() => handleChange("a4", "document_size")}
                  >
                    A4
                  </div>
                </div>
              </div>

              {/* <div className="p-0 mr-2">
                <BootstrapSwitchButton
                  checked={
                    resume && resume.resume && resume.resume.isLetter
                      ? true
                      : false
                  }
                  onstyle="outline-success"
                  offstyle="outline-success"
                  width={77}
                  onlabel="Letter"
                  offlabel="A4"
                  size="sm"
                  onChange={(checked) => handleChange(checked, "document_size")}
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideTemplate;
